import React from 'react'

import { Box, InlineButton, Text } from '@driftt/dds'

import { useTruncatedText } from 'hooks/useTrucatedText'

import './styles.css'

export const TruncatedText = ({
  content,
  useToggle = false
}: {
  content: string
  useToggle?: boolean
}) => {
  const ref = React.useRef(null)
  const { isTruncated, isShowingMore, toggleIsShowingMore } = useTruncatedText({
    ref
  })

  return useToggle ? (
    <Box>
      <Text
        ref={ref}
        className={`${!isShowingMore && 'lineClamp'}`}
        dangerouslySetInnerHTML={{ __html: content }}
        css={{ width: '100%' }}
      />
      {isTruncated && !isShowingMore && (
        <InlineButton onClick={toggleIsShowingMore}>view more</InlineButton>
      )}
    </Box>
  ) : (
    <Text
      ref={ref}
      className={'lineClamp'}
      dangerouslySetInnerHTML={{ __html: content }}
      css={{ width: '100%' }}
    />
  )
}
